import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useTheme } from 'vuetify'

export const useThemeStore = defineStore('theme', () => {
  const currentTheme = ref<string>('BLUE_THEME')
  
  // Initialize theme from localStorage
  const initializeTheme = () => {
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme && (savedTheme === 'BLUE_THEME' || savedTheme === 'DARK_BLUE_THEME')) {
      currentTheme.value = savedTheme
    }
  }
  
  // Computed for checking if dark mode
  const isDark = computed(() => currentTheme.value === 'DARK_BLUE_THEME')
  
  // Toggle theme function
  const toggleTheme = () => {
    currentTheme.value = isDark.value ? 'BLUE_THEME' : 'DARK_BLUE_THEME'
    localStorage.setItem('theme', currentTheme.value)
  }
  
  // Set specific theme
  const setTheme = (theme: string) => {
    if (theme === 'BLUE_THEME' || theme === 'DARK_BLUE_THEME') {
      currentTheme.value = theme
      localStorage.setItem('theme', theme)
    }
  }
  
  // Apply theme to Vuetify
  const applyTheme = (vuetifyTheme: ReturnType<typeof useTheme>) => {
    vuetifyTheme.global.name.value = currentTheme.value
  }
  
  return {
    currentTheme,
    isDark,
    initializeTheme,
    toggleTheme,
    setTheme,
    applyTheme
  }
})